import * as ActionsDialog from 'app/store/actions';
import axios from 'axios';
import decode from 'jwt-decode';
import { API_BASE_URL } from '@config';

// SET
export const SET_MARKET_STACKS_LIST = 'SET_MARKET_STACKS_LIST';
export const setMarketStacksList = marketStacks => ({
	type: SET_MARKET_STACKS_LIST,
	payload: marketStacks
});

export const SET_STACK = 'SET_STACK';
export const setStack = stack => ({
	type: SET_STACK,
	payload: stack
});

export const SET_FILTER = 'SET_FILTER';
export const setFilter = filter => ({
	type: SET_FILTER,
	payload: filter
});

export const SET_LOGS = 'SET_LOGS';
export const setLogs = logs => ({
	type: SET_LOGS,
	payload: logs
});

export const SET_MARKETPLACE_ERROR = 'SET_MARKETPLACE_ERROR';
export const setMarketPlaceError = error => ({
	type: SET_MARKETPLACE_ERROR,
	payload: error
});

// CLEAR
export const CLEAR_STACK = 'CLEAR_STACK';
export const clearStack = () => ({
	type: CLEAR_STACK,
});

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const CLEAR_LOGS = 'CLEAR_LOGS';
export const clearLogs = () => ({
	type: CLEAR_LOGS
});

// * ////////////// GET ////////////// * //

export const SET_MARKETPLACE_LOADING = 'SET_MARKETPLACE_LOADING';

export const getMarketplaceStacks = () => (dispatch, getState) => {
	const { marketplace } = getState();
	// Prevent redundant fetches if already loaded or currently loading
	if (marketplace && (marketplace.loaded || marketplace.loading)) {
		return;
	}

	dispatch({ type: SET_MARKETPLACE_LOADING });
	dispatch(ActionsDialog.toggleLoading());

	axios
		.get(`${API_BASE_URL}/api/marketplace/apps`)
		.then(response => {
			const marketplaceData = response.data;

			if (!Array.isArray(marketplaceData)) {
				console.error('Marketplace data is not an array:', marketplaceData);
				throw new Error('Invalid marketplace data format');
			}

			dispatch(setMarketStacksList(marketplaceData));
		})
		.catch(error => {
			console.error('Failed to load marketplace data:', error);
			dispatch(setMarketPlaceError(`Failed to load marketplace data: ${error.message}`));
		})
		.finally(() => {
			dispatch(ActionsDialog.toggleLoading());
		});
};


export const getStack = stack => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(setStack(stack));
	dispatch(ActionsDialog.toggleLoading());
};

export const getLogs = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(setLogs())
	dispatch(ActionsDialog.toggleLoading());
};

// * ////////////// POST ////////////// * //
// Marketplace SSO Token Generation Action
export const generateMarketplaceSSO = (appConfig) => dispatch => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${API_BASE_URL}/api/marketplace-sso/generate-token`, { appConfig })
			.then(response => {
				if (response.data && response.data.success) {
					resolve(response.data.token);
				} else {
					reject(response.data.error || 'Failed to generate marketplace SSO token');
				}
			})
			.catch(err => {
				console.error('Error generating marketplace SSO token:', err);
				reject(err);
			});
	});
};


// * ////////////// PUT ////////////// * //

export const editStack = stack => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(getStack())
	dispatch(ActionsDialog.toggleLoading());
};

/**
 * Fetch a provision script from the secure backend endpoint.
 * @param {string} scriptPath - The provision_script value from the app config 
 *   (e.g. "/api/marketplace/provision-script/classifyx.sh" or legacy "/assets/marketplace-data/scripts/classifyx.sh")
 * @returns {Promise<string>} The script content
 */
export const getProvisionScript = (scriptPath) => () => {
	// Extract just the filename from legacy or new paths
	let filename = scriptPath;
	if (scriptPath.includes('/')) {
		filename = scriptPath.split('/').pop();
	}

	return axios
		.get(`${API_BASE_URL}/api/marketplace/provision-script/${filename}`, {
			transformResponse: [data => data] // Return raw text, not parsed JSON
		})
		.then(response => response.data);
};


